/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ServiceSubscriberDto { 
    _Id?: string;
    id?: number;
    phonenumber?: string;
    subscribed?: boolean;
    startDate?: Date;
    expiryDate?: Date;
    serviceCode?: string;
    serviceId?: string;
    serviceName?: string;
    serviceProviderName?: string;
    dateCreated?: Date;
    autoRenew?: boolean;
}